export default {
  en: {
    translation: {
      unsplash: {
        no_auth_title: 'Access millions of images from Unsplash.',
        no_auth_action: 'Connect to Unsplash',
        no_auth_statement:
          'Beautiful, free images and photos that you can download and use for any project. Better than any royalty free or stock photos.',
        select: 'Select',
        popular_categories: 'Popular categories',
        editorial: 'Editorial',
        filters: {
          toggle_filters_button: 'Filters',
          clear: 'Clear',
          sort_options: {
            label: 'Sort by',
            latest: 'Latest',
            oldest: 'Oldest',
            relevant: 'Relevant',
            popular: 'Popular',
          },
          orientation: {
            label: 'Orientation',
            portrait: 'Portrait',
            landscape: 'Landscape',
            squarish: 'Squarish',
          },
          categories: {
            label: 'Categories',
          },
          license: {
            label: 'License Type',
            creative: 'Creative',
            editorial: 'Editorial',
          },
          colors: {
            label: 'Colors',
          },
          summary: {
            label: 'Filters',
            color: 'Color: {{color}}',
          },
          filters_in: 'in',
          color_types: {
            tones: 'Tones',
            black_and_white: 'Black and white',
          },
        },
        summary: {
          description: 'Description',
          permission: 'Permission',
          free_to_use: 'Free to use',
          published_at: 'Published at',
          location: 'Location',
          credit: 'Credit',
          format: 'Select Format & Size',
          size: {
            small: 'Small',
            medium: 'Medium',
            large: 'Large',
            original_size: 'Original size',
          },
        },
        colors: {
          orange: 'Orange',
          red: 'Red',
          yellow: 'Yellow',
          green: 'Green',
          teal: 'Teal',
          blue: 'Blue',
          purple: 'Purple',
          magenta: 'Magenta',
          white: 'White',
          black: 'Black',
          black_and_white: 'Black and white',
        },
      },
    },
  },
};
